import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { testimonials } from '../utils/mockData';
import { ChevronLeft, ChevronRight, Quote } from 'lucide-react';
import { Button } from './ui/button';

export const TestimonialsSection = () => {
  const { language, t } = useLanguage();
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const current = testimonials[currentIndex];

  return (
    <section className="py-24 relative overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1570804485046-b5b8d795dc5d?crop=entropy&cs=srgb&fm=jpg&q=85"
          alt="Background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-[#2C2C2C]/80 backdrop-blur-sm"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16 fade-in-up">
          <h2 className="font-serif text-4xl md:text-5xl text-[#FAF9F7] mb-4">
            {t('testimonialsTitle')}
          </h2>
        </div>

        {/* Testimonial Card */}
        <div className="bg-white/10 backdrop-blur-md rounded-lg p-8 md:p-12 shadow-2xl fade-in-up" style={{ animationDelay: '0.2s' }}>
          <Quote className="h-12 w-12 text-[#C4B5A0] mb-6" />
          
          <blockquote className="text-lg md:text-xl text-[#FAF9F7] leading-relaxed mb-8 italic">
            {language === 'en' ? current.quote : current.quoteEs}
          </blockquote>
          
          <div className="flex items-center space-x-4">
            {current.image && (
              <img
                src={current.image}
                alt={current.author}
                className="w-16 h-16 rounded-full object-cover border-2 border-[#C4B5A0]"
              />
            )}
            <div>
              <p className="font-medium text-[#FAF9F7] text-lg">{current.author}</p>
              <p className="text-[#C4B5A0] text-sm">
                {language === 'en' ? current.role : current.roleEs} | {language === 'en' ? current.location : current.locationEs}
              </p>
            </div>
          </div>

          {/* Navigation */}
          <div className="flex items-center justify-center space-x-4 mt-8">
            <Button
              onClick={prevTestimonial}
              variant="ghost"
              size="sm"
              className="text-[#FAF9F7] hover:bg-white/10"
            >
              <ChevronLeft className="h-5 w-5" />
            </Button>
            
            <div className="flex space-x-2">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentIndex(index)}
                  className={`w-2 h-2 rounded-full transition-all ${
                    index === currentIndex ? 'bg-[#C4B5A0] w-8' : 'bg-white/30'
                  }`}
                  aria-label={`Go to testimonial ${index + 1}`}
                />
              ))}
            </div>
            
            <Button
              onClick={nextTestimonial}
              variant="ghost"
              size="sm"
              className="text-[#FAF9F7] hover:bg-white/10"
            >
              <ChevronRight className="h-5 w-5" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};